import React from "react";
import { useState, useRef } from "react";
import css from "./ResetPassword.module.scss";
import { NavLink,useNavigate } from "react-router-dom";
import { bg_reset_password } from "../../../Images";
import { DoVerificationOTP } from "../../../Services/AuthServices";

const VerificationPage = () => {
  
  const navigation = useNavigate();
  const itemsRef = useRef([]);
  const [userInput, setUserInput] = useState("");
  const [ErrorType, setErrorType] = useState(0);
  const email = localStorage.getItem("email_forgot");

  const codeChangeHandler = (event) => {
    const [, codeFieldIndex] = event.target.name.split("-");
    let fieldIntIndex = parseInt(codeFieldIndex, 10);
    setUserInput((prevState) => prevState + event.target.value);

    if (fieldIntIndex < 4) {
      itemsRef.current[fieldIntIndex + 1].focus();
    } else {
      const field = document.querySelector(`Input[name=code-${fieldIntIndex}]`);
      field.blur();
    }
  };


  const codeInputFields = new Array(5)
    .fill(0)
    .map((item, index) => (
      <input
        ref={(ref) => itemsRef.current.push(ref)}
        name={`code-${index}`}
        key={index}
        onChange={(event) => codeChangeHandler(event)}
        maxLength={1}
      />
    ));
    

    async function VerificationCode() {
      
      try {
        var data = new FormData();
        data.append("email", localStorage.getItem("email_forgot"));
        data.append("otp", userInput);
        

        const execute = await DoVerificationOTP(data);
        if (execute.status === 200) {
          navigation('/change-password') 
        }
        console.log(execute)
      } catch (error) {
        console.log(error)
        
        setErrorType(error.response.status)
      }
    }

  return (
    <div
      className="backgrund-cover-no-repeat"
      style={{ backgroundImage: `url(${bg_reset_password})`, height: "100vh" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3">
            <div className={css.header_dark}>
              <NavLink to="/reset-password">
                <div className={css.back_button}>
                  <i class="fi-rr-arrow-small-left" />
                </div>
                <label>Forgot Password </label>
              </NavLink>
            </div>
          </div>
        </div>
        <div className={css.wrap_form_verification}>
          <div className="row pt-4">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3 text-center">
              <div className={css.title}>Email Verification</div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
              <div className={css.desc}>
                Use your registered email address{" "}
                <label className="green-font">{email}</label> to
                obtain a verification code.
              </div>
            </div>
          </div>
          <div className="row p-3 pt-5">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3 pb-4 background-gray">
              <label>Email Verification Code</label>
              <div className={css.digit_input}>
                {codeInputFields}
              </div>
              {ErrorType === 401 && <label className={css.error_message}>Please input the valid verification code sent to your email.</label>}

            </div>
          </div>
        </div>
        <div className="row pt-4">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3 text-center">
          {ErrorType === 401 && 
            <div className={css.info}>
              Don't have receive code? <br />
              <NavLink to="/reset-password">
                <u className="green-font">Request code again</u>
              </NavLink>
            </div>
          }
          </div>
        </div>
      </div>

      <div className={css.button_bottom_wrap}>
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <button onClick={VerificationCode}>Send Code</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerificationPage;
